module.exports = __webpack_public_path__ + "static/media/star_on.03c1f726.png";